// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"67e1ad71","700":"e9973cd0"}[chunkId] + ".chunk.css";
};